import React from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useCurrentProject } from "../hooks/useCurrentProject";

// 项目作用域路由守卫：
// - projects 加载中 → 转圈
// - 加载完成但 :projectKey 无效 → 回项目列表
// - 命中 → 渲染子页面
const ProjectGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loading, project, notFound } = useCurrentProject();

  if (notFound) return <Navigate to="/" replace />;
  if (loading && !project) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 80 }}>
        <Spin />
      </div>
    );
  }
  return <>{children}</>;
};

export default ProjectGuard;
